import React from "react";
import axios from "axios";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export function NewsletterSection() {
  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.elements.newsletter_email.value.trim();
    if (!email) return;
    try {
      const response = await axios.post(`${API_URL}/contact/newsletter`, { email, source: 'landing_page' });
      if (response.data.status === 'success') {
        toast.success(response.data.message);
        e.target.reset();
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong');
    }
  };

  return (
    <section className="relative z-10 px-6 md:px-12 lg:px-24 py-20 bg-gradient-to-b from-[#0A0A0A] to-[#111]">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">Stay Ahead of the Market</h2>
        <p className="text-gray-400 mb-8 text-sm md:text-base">
          Get weekly real estate marketing tips, product updates, and early-access perks — straight to your inbox. Be among the first to know what's next.
        </p>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
          data-testid="newsletter-form"
        >
          <input
            name="newsletter_email"
            type="email"
            required
            placeholder="you@brokerage.com"
            className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-500 focus:outline-none focus:border-[#39FF14] focus:ring-1 focus:ring-[#39FF14] text-sm"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-[#39FF14] text-black font-semibold rounded-lg hover:bg-[#32E012] transition-colors text-sm whitespace-nowrap"
            data-testid="newsletter-submit-btn"
          >
            Subscribe
          </button>
        </form>
        <p className="text-gray-600 text-xs mt-4">No spam. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
